export const alwaysUndefined = () => undefined;